<div class="settings">
    <div class="settings__left-grid">
        @if (playlistContents().length > 0) {
            <app-playlist-grid
                [playlistContents]="playlistContents()"
                [showRemoveControl]="true"
                (remove)="removeContent($event)"
                (reorder)="onReorder($event)" />
        } @else {
            <p>No contents added.</p>
        }
    </div>
    <div class="settings__right-grid">
        <app-playlist-settings-content
            [showForTM]="true"
            [showPlaylistTabs]="false"
            [initialData]="settingsDraft()"
            [visibleTabs]="['basics', 'content-schedule']"
            (settingsChange)="onSettingsChange($event)" />
    </div>
</div>
